const FakeData = [
  { id: 1, name: "PSYCHO TRAINING", image: "https://i.imgur.com/tUzK7uX.png" },
  { id: 2, name: "SELF DEFENCE", image: "https://i.imgur.com/Vr9ZQVb.jpg" },
  { id: 3, name: "ADVANCE GYM", image: "https://i.imgur.com/BtfTvZc.jpg" },
  { id: 4, name: "CARDIO TRAINING", image: "https://i.imgur.com/RH0fd30.jpg" },
  {
    id: 5,
    name: "STREINGHT TRAINING",
    image: "https://i.imgur.com/cDIqTtz.jpg",
  },
  { id: 6, name: "PSYCHI TRAINING", image: "https://i.imgur.com/OFS8dz9.jpg" },
];

export default FakeData;
